module.exports = __webpack_public_path__ + "static/media/mercadolibre.9d4ae81f.png";